import  { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Button, Offcanvas } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import Logo from "../../assets/image/navbar.png";

function NavBar() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const location = useLocation();

  const navItems = ["Home", "About", "Features", "Pricing", "Contact"];

  const renderNavLinks = (isMobile = false) =>
    navItems.map((item, index) => {
      const path = item === "Home" ? "/" : `/${item.toLowerCase()}`;
      const isActive = location.pathname === path;

      return (
        <Nav.Link
          as={NavLink}
          to={path}
          key={index}
          className={`nav-item ${isActive ? "active-nav-item" : ""}`}
          onClick={isMobile ? handleClose : undefined}
        >
          {item}
        </Nav.Link>
      );
    });

  return (
    <Navbar expand="md" className="custom-navbar" fixed="top">
      <Container>
        <Navbar.Brand as={NavLink} to="/">
          <img src={Logo} alt="Logo" width="150" className="img-fluid" />
        </Navbar.Brand>

        <Button className="d-md-none toggle-button" onClick={handleShow}>
          <FaBars size={20} />
        </Button>

        <Navbar.Collapse className="justify-content-end d-none d-md-flex">
          <Nav className="ml-auto align-items-center">
            {renderNavLinks()}
            <Button
              variant="primary"
              as={NavLink}
              to="/signin"
              className="custom-signin-button ms-3"
            >
              Sign In
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="custom-offcanvas"
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            {renderNavLinks(true)}
            <Button
              variant="primary"
              as={NavLink}
              to="/signin"
              className="custom-signin-button mt-3 w-100"
              onClick={handleClose}
            >
              Sign In
            </Button>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </Navbar>
  );
}

export default NavBar;
